import * as React from 'react'
import { ReactNode } from 'react'

import { Icon, IconProps } from './Icon'
import { Accordion, AccordionDetails, AccordionSummary } from './Accordion'

import Typography from '@mui/material/Typography'
import ExpandMore from '@mui/icons-material/ExpandMore'

type Props = {
  title: string
  children: ReactNode
  icon?: IconProps['icon']
  defaultExpanded?: boolean
}

export function Panel(props: Props) {
  const { icon, title, children, defaultExpanded } = props

  return (
    <Accordion square elevation={0} defaultExpanded={defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMore color="primary" />}>
        {!!icon && <Icon icon={icon} />}

        <Typography variant="h6">{title}</Typography>
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}
